module.exports = __webpack_public_path__ + "assets/img/iso_27001_light.1571a917.png";